import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import styles from './Ibtikar.module.css';
import axios from 'axios';
import { API } from '../../../config/API';
import Loader from '../../../components/Loader/Loader';
import { Util } from '../../../config/Util';
import toast from 'react-hot-toast';



const Facilitation = () => {
    const [data, setData] = useState([]);
    const [fullData, setFullData] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [assignOpen, setAssignOpen] = useState(false);
    const [assignRow, setAssignRow] = useState(null);
    const [assignee, setAssignee] = useState('');
    const [userSearchTerm, setUserSearchTerm] = useState('');
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [uniqueUsers, setUniqueUsers] = useState([]);
    const [loader, setLoader] = useState(false);
    const [closeOpen, setCloseOpen] = useState(false);
    const [closeRow, setCloseRow] = useState(null);
    const [closeChecked, setCloseChecked] = useState(false);
    const [rejectOpen, setRejectOpen] = useState(false);
    const [rejectRow, setRejectRow] = useState(null);
    const [rejectChecked, setRejectChecked] = useState(false);
    const [rejectComment, setRejectComment] = useState('');
    const [forwardOpen, setForwardOpen] = useState(false);
    const [forwardRow, setForwardRow] = useState(null);
    const [forwardChecked, setForwardChecked] = useState(false);
    const [forwardDepartment, setForwardDepartment] = useState('');
    
    const [departmentId, setDepartmentId] = useState();
    const [departments, setDepartments] = useState([]);

    
    useEffect(() => {
        const initializeFunctions = async () => {
            await fetchDepartments();
            await listUsers();
        };
        initializeFunctions();
    }, []);

    // when departmentId becomes available, load ideas for that department
    useEffect(() => {
        if (departmentId) {
            listIdeas();
        }
    }, [departmentId]);

    const listIdeas = async()=>{
        if (!departmentId) return;
        try {
            setLoader(true);
            const resp = await axios.get(API.ideaList, { params: { departmentId } });
            if (resp && resp.status === 200 && resp.data && resp.data.status === "S") {
                setData(resp.data.ideas);
                setFullData(resp.data.ideas);
            }
        } catch (er) {
            console.log(er);
        } finally {
            setLoader(false);
        }
    }

    const fetchDepartments = async () => {
        try {
            const resp = await axios.get(API.getDepartmentData);
            if (resp && resp.status === 200) {
                setDepartments(resp.data || []);
            }
        } catch (er) {
            console.log(er);
        }
    };

    const listUsers = async () => {
        try {
            setLoader(true);
            const resp = await axios.get(API.listUser);
            if (resp && resp.status === 200 && resp.data) {
                // Exclude super admin users
                const filteredUsers = resp.data.users.filter(user => user.role !== 'SUPER_ADMIN');
                setUniqueUsers(filteredUsers);
                setFilteredUsers(filteredUsers);
                // derive department id for logged-in user from response directly
                const auth = Util.getFromSession("auth");
                const currentUser = filteredUsers.find(u => Number(u.id) === Number(auth?.id));
                const depId = currentUser && Array.isArray(currentUser.groups) && currentUser.groups[0] ? currentUser.groups[0].id : undefined;
                setDepartmentId(depId);
            }
        } catch (er) {
            console.log(er);
        } finally {
            setLoader(false);
        }
    };

    const handleUserSearch = (searchTerm) => {
        setUserSearchTerm(searchTerm);
        if (!searchTerm) {
            setFilteredUsers(uniqueUsers);
            setAssignee('');
        } else {
            const filtered = uniqueUsers.filter(user => {
                const searchLower = searchTerm.toLowerCase();
                return (
                    (user.username && user.username.toLowerCase().includes(searchLower)) ||
                    (user.name && user.name.toLowerCase().includes(searchLower))
                );
            });
            setFilteredUsers(filtered);
            
            // Auto-select if there's only one match
            if (filtered.length === 1) {
                setAssignee(filtered[0].id);
            } else if (filtered.length === 0) {
                setAssignee('');
            }
        }
    };

    const handleUserSearchKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            // If there's exactly one match, select it
            if (filteredUsers.length === 1) {
                setAssignee(filteredUsers[0].id);
            }
            // If there are multiple matches, select the first one
            else if (filteredUsers.length > 1) {
                setAssignee(filteredUsers[0].id);
            }
        }
    };

    const openAssignModal = (row) => {
        setAssignRow(row);
        setAssignOpen(true);
        setUserSearchTerm('');
        setFilteredUsers(uniqueUsers);
    };

    const handleAssign = () => {
        setLoader(true);
        const req = {
            id: assignRow.id,
            assignee: assignee
        }
        console.log(req);
        axios.post(API.assignIdea, req).then((resp) => {
            if (resp.status === 200 && resp.data && resp.data.status ==="S") {
                console.log(resp.data)
                setLoader(false);
                setAssignOpen(false); setAssignRow(null); setAssignee('');
                toast.success('Idea assigned for implementation successfully');
                listIdeas();
            }
        }).catch((er) => {
           toast.error("Failed to assign! Please try again later");
            console.log(er)
        }).finally(() => {
            setLoader(false);
        })
    };

    const getStatusClass = (status) => {
    if (!status) return '';
    const s = String(status).toLowerCase();
    if (s.includes('completed')) return styles.statusApproved; // completed -> green
        if (s.includes('rejected')) return styles.statusRejected;  // rejected -> red
        if (s.includes('open')) return styles.statusOpen;
        if (s.includes('implementation')) return styles.statusImplementation;
        if (s.includes('review')) return styles.statusReview;
    return '';
    };

    const getUsername = (id) => {
      if (id === undefined || id === null) return 'NA';
      const user = uniqueUsers.find(u => Number(u.id) === Number(id));
      if (!user) return 'NA';
      const username = user.username || '';
      const name = user.name || '';
      if (username && name) return `${username} - ${name}`;
      return username || name || 'NA';
    };

    const getSubmittedBy = (empId) => {
      if (!empId) return 'NA';
      const user = uniqueUsers.find(u => u.username === empId || u.name === empId);
      if (!user) return empId;
      const username = user.username || '';
      const name = user.name || '';
      if (username && name) return `${username} - ${name}`;
      return username || name || empId;
    };

    const columns = [
        { name: 'ID', selector: row => row.id, sortable: true, center: true, grow: 0.5, maxWidth: '60px' },
        {
            name: 'TITLE',
            selector: row => row.ideaProblem,
            sortable: true,
            center: true,
            grow: 3,
            cell: row => (
                <span className={styles.tableEllipsis} title={row.ideaProblem}>
                    {row.ideaProblem}
                </span>
            ),
            minWidth: '120px',
            maxWidth: '240px',
        },
        { name: 'DATE', selector: row => row.ideaDate, center: true, maxWidth: '90px' },
        {
            name: 'SUBMITTED BY',
            selector: row => getSubmittedBy(row.empId),
            center: true,
            cell: row => {
                const label = getSubmittedBy(row.empId);
                return <span className={styles.tableEllipsis} title={label}>{label}</span>;
            },
        },
        {
            name: 'ASSIGNEE',
            selector: row => (row && row.assignee ? getUsername(row.assignee) : 'NA'),
            center: true,
            cell: row => {
                const label = row && row.assignee ? getUsername(row.assignee) : 'NA';
                return <span className={styles.tableEllipsis} title={label}>{label}</span>;
            },
        },
        { name: 'STATUS', selector: row => (row && row.status ? String(row.status).toUpperCase() : ''), center: true, maxWidth: '130px' },
        {
            name: '',
            cell: row => (
              <button
                className='btn btn-info'
                onClick={() => { setModalData(row); setModalOpen(true); }}
              >
                VIEW
              </button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
          },
        {
            name: '',
            cell: row => {
              const status = row && row.status ? String(row.status).toLowerCase() : '';
              const canAssign = status.includes('open') || status.includes('review');
              return (
                <button
                  className='btn btn-success'
                  disabled={!canAssign}
                  onClick={() => { if (canAssign) { openAssignModal(row); } }}
                >
                  ASSIGN
                </button>
              );
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
        {
            name: '',
            cell: row => {
              const status = row && row.status ? String(row.status).toLowerCase() : '';
              const canClose = status.includes('review');
              return (
                <button
                  className='btn btn-warning'
                  disabled={!canClose}
                  onClick={() => { if (canClose) { setCloseRow(row); setCloseChecked(false); setCloseOpen(true); } }}
                >
                  CLOSE
                </button>
              );
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
        {
            name: '',
            cell: row => {
              const status = row && row.status ? String(row.status).toLowerCase() : '';
              const canReject = status.includes('open');
              return (
                <button
                  className='btn btn-danger'
                  disabled={!canReject}
                  onClick={() => { if (canReject) { setRejectRow(row); setRejectChecked(false); setRejectOpen(true); } }}
                >
                  REJECT
                </button>
              );
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];


    const handleCloseConfirm = async() => {
        if (!closeRow || !closeRow.id) {
            setCloseOpen(false);
            setCloseChecked(false);
            return;
        }
        setLoader(true);
        setCloseOpen(false);
        setCloseRow(null);
        setCloseChecked(false);
        try {
            const req = { id: closeRow.id, status: 'completed' };
            const resp = await axios.post(API.updateIdeaStatus, req);
            //let res = {status : 200};
            if (resp && (resp.status === 200 || resp.status === 201) && resp.data && resp.data.status === "S") {

                toast.success("Successfully closed the idea");
                await listIdeas();
            } else {
                toast.error("Failed to close the idea");
                console.log('Unexpected response', resp);
            }
        } catch (er) {
            console.log(er);
        } finally {
            setLoader(false);
        }
    };

    const handleRejectConfirm = async() => {
        if (!rejectRow || !rejectRow.id) {
            setRejectOpen(false);
            setRejectChecked(false);
            return;
        }
        setLoader(true);
        // close modal and clear selection early (same as close flow)
        setRejectOpen(false);
        setRejectRow(null);
        setRejectChecked(false);
        const comment = rejectComment;
        setRejectComment('');
        try {
            const req = { id: rejectRow.id, status: 'rejected', comment: comment || '' };
            const resp = await axios.post(API.updateIdeaStatus, req);
            if (resp && (resp.status === 200 || resp.status === 201) && resp.data && resp.data.status === "S") {
                toast.success('Successfully rejected the idea');
                await listIdeas();
            } else {
                toast.error('Failed to reject the idea');
                console.log('Unexpected response', resp);
            }
        } catch (er) {
            console.log(er);
        } finally {
            setLoader(false);
        }
    };

    const handleForwardConfirm = async() => {
        if (!forwardRow || !forwardRow.id) {
            setForwardOpen(false);
            setForwardChecked(false);
            setForwardDepartment('');
            return;
        }
        if (!forwardDepartment) {
            toast.error('Please select a department');
            return;
        }
        setLoader(true);
        setForwardOpen(false);
        setForwardRow(null);
        setForwardChecked(false);
        const selectedDept = forwardDepartment;
        setForwardDepartment('');
        try {
            const req = { id: forwardRow.id, departmentId: selectedDept };
            const resp = await axios.post(API.forwardIdea, req);
            if (resp && (resp.status === 200 || resp.status === 201) && resp.data && resp.data.status === "S") {
                toast.success('Successfully forwarded the idea to review');
                await listIdeas();
            } else {
                toast.error('Failed to forward the idea');
                console.log('Unexpected response', resp);
            }
        } catch (er) {
          toast.error('Failed to forward the idea. Please try again later.');
            console.log(er);
        } finally {
            setLoader(false);
        }
    };

    const forwardIdea = (idea) => {
        setModalOpen(false);
        setModalData(null);
        setForwardRow(idea);
        setForwardChecked(false);
        setForwardDepartment('');
        setForwardOpen(true);
    };

    const filterData = (e) => {
        const key = e.target.value || '';
        if (!key) return setData(fullData);
        const filtered = fullData.filter(item => item.name.toLowerCase().includes(key.toLowerCase()));
        setData(filtered);
    };

    return (
        <>
        <Loader loading={loader} />
        <div className={styles.container || ''} data-testid="ibtikar-facilitation">
            <div className='bread-crumb overflow-auto'>
                <div>
                    <span className='breadcrumb-title'>
                        <input type='button' className='btn' value='Home - Facilitation'></input>
                    </span>
                </div>
            </div>

            <div className='data-table-holder'>
                <div className='table-search-box'>
                    <input type='text' placeholder='Search Here..' className='form-control' onChange={filterData} />
                </div>

                <DataTable
                    subHeaderAlign='center'
                    columns={columns}
                    data={data}
                    pagination
                    striped
                />
                {modalOpen && modalData && (
  <div className={styles.modalOverlay}>
    <div className={`${styles.modalCard} card p-0`}>
      <div className={`d-flex justify-content-between align-items-center ${styles.modalHeader}`}>
        <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
          <h5 className='m-0'>Submission Details</h5>
          <span className={`${styles.statusBadge} ${getStatusClass(modalData.status)}`}>{modalData.status || 'Unknown'}</span>
        </div>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          {modalData.status && String(modalData.status).toLowerCase() === 'open' && (
            <button 
              className='btn btn-primary' 
              onClick={() => forwardIdea(modalData)}
            >
              FORWARD IDEA
            </button>
          )}
          {modalData.status && String(modalData.status).toLowerCase() === 'review' && (
            <button 
              className='btn btn-warning' 
              onClick={() => { 
                setModalOpen(false); 
                setModalData(null);
                setCloseRow(modalData); 
                setCloseChecked(false); 
                setCloseOpen(true); 
              }}
            >
              CLOSE IDEA
            </button>
          )}
          <button className={`btn btn-danger `} onClick={() => { setModalOpen(false); setModalData(null); }}>X</button>
        </div>
      </div>
      <div className={styles.modalBody}>
        <div className={styles.modalSection}>
          <div className={styles.modalSectionTitle}>Submission Info</div>
          <div className='row'>
            <div className='col-sm-6'>
              <div className={styles.modalField}><strong>ID:</strong> {modalData.id}</div>
            </div>
            <div className='col-sm-6'>
              <div className={styles.modalField}><strong>Title:</strong> {modalData.name || modalData.ideaProblem}</div>
            </div>
            <div className='col-sm-6'>
              <div className={styles.modalField}><strong>Submitted:</strong> {modalData.submitted || modalData.ideaDate || (modalData.meta && modalData.meta.idea_date)}</div>
            </div>
            <div className='col-sm-6'>
              <div className={styles.modalField}><strong>Submit Type:</strong> {modalData.submitType || (modalData.meta && modalData.meta.submitType)}</div>
            </div>
            <div className='col-sm-6'>
              <div className={styles.modalField}><strong>Employee ID:</strong> {modalData.empId || (modalData.meta && modalData.meta.empId)}</div>
            </div>
            <div className='col-sm-6'>
              <div className={styles.modalField}><strong>Category:</strong> {modalData.category || (modalData.meta && modalData.meta.category) || <span className={styles.modalTextMuted}>-</span>}</div>
            </div>
            <div className='col-sm-6'>
              <div className={styles.modalField}><strong>Sub-Category:</strong> {modalData.subCategory || (modalData.meta && modalData.meta.subCategory) || <span className={styles.modalTextMuted}>-</span>}</div>
            </div>
            <div className='col-sm-6'>
              <div className={styles.modalField}><strong>Email:</strong> {modalData.submitterEmail || (modalData.meta && modalData.meta.submitter && modalData.meta.submitter.email) || <span className={styles.modalTextMuted}>-</span>}</div>
            </div>
            <div className='col-sm-6'>
              <div className={styles.modalField}><strong>Phone:</strong> {modalData.submitterPhone || (modalData.meta && modalData.meta.submitter && modalData.meta.submitter.phone) || <span className={styles.modalTextMuted}>-</span>}</div>
            </div>
            {(modalData.submitType === 'group' || (modalData.meta && modalData.meta.submitType === 'group')) && (modalData.members || (modalData.meta && modalData.meta.members)) && (
              <div className='col-sm-12'>
                <div className={styles.modalField}>
                  <strong>Group Members:</strong> 
                  <div style={{ marginTop: '6px', display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                    {(modalData.members || (modalData.meta && modalData.meta.members) || []).map((member, index) => (
                      <span 
                        key={index}
                        style={{
                          padding: '4px 10px',
                          backgroundColor: '#e3f2fd',
                          borderRadius: '12px',
                          fontSize: '13px',
                          color: '#1976d2'
                        }}
                      >
                        {member}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className={styles.modalSection}>
          <div className={styles.modalSectionTitle}>Idea Details</div>
          <div className={styles.modalField}><strong>Idea / Problem:</strong><br />{modalData.ideaProblem || (modalData.meta && modalData.meta.ideaProblem) || <span className={styles.modalTextMuted}>-</span>}</div>
          <div className={styles.modalField}><strong>Root Cause:</strong><br />{modalData.rootCause || (modalData.meta && modalData.meta.rootCause) || <span className={styles.modalTextMuted}>-</span>}</div>
          <div className={styles.modalField}><strong>Solution Proposed:</strong><br />{modalData.solutionProposed || (modalData.meta && modalData.meta.solutionProposed) || <span className={styles.modalTextMuted}>-</span>}</div>
          <div className={styles.modalField}><strong>Benefits:</strong><br />{modalData.benefits || (modalData.meta && modalData.meta.benefits) || <span className={styles.modalTextMuted}>-</span>}</div>
          {modalData.rejectionComment && (
            <div className={styles.modalField}><strong>Rejection comment:</strong><br />{modalData.rejectionComment}</div>
          )}
          {modalData.implementorComment && (
            <div className={styles.modalField}><strong>Implementor Comment:</strong><br />{modalData.implementorComment}</div>
          )}

          <div className={styles.modalRow} style={{ marginTop: '0.5rem' }}>
            <div style={{ flex: '1 1 300px' }}>
              <div className={styles.modalField}><strong>Before Image:</strong></div>
              {modalData.beforeImage ? (
                typeof modalData.beforeImage === 'string' ? <img className={styles.modalImage} src={modalData.beforeImage.startsWith('http') ? modalData.beforeImage : Util.baseURlForDownload + modalData.beforeImage} alt='before' /> : <div className='text-muted'>{modalData.beforeImage.name || 'Uploaded file'}</div>
              ) : <div className='text-muted'>No image</div>}
            </div>
            <div style={{ flex: '1 1 300px' }}>
              <div className={styles.modalField}><strong>After Image:</strong></div>
              {modalData.afterImage ? (
                typeof modalData.afterImage === 'string' ? <img className={styles.modalImage} src={modalData.afterImage.startsWith('http') ? modalData.afterImage : Util.baseURlForDownload + modalData.afterImage} alt='after' /> : <div className='text-muted'>{modalData.afterImage.name || 'Uploaded file'}</div>
              ) : <div className='text-muted'>No image</div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)}
                {assignOpen && assignRow && (
                  <div className={styles.modalOverlay}>
                    <div className={`${styles.modalCard} card p-0`}>
                      <div className={`d-flex justify-content-between align-items-center ${styles.modalHeader}`}>
                        <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                          <h5 className='m-0'>Assign for Implementation</h5>
                        </div>
                        <button className={`btn btn-danger `} onClick={() => { setAssignOpen(false); setAssignRow(null); }}>X</button>
                      </div>
                      <div className={styles.modalBody}>
                        <div className={styles.modalSection}>
                          <div className={styles.modalField}>
                            <label className='font-weight-bold' style={{ display: 'block', marginBottom: '0.5rem' }}>Assign to user:</label>
                            <div style={{ position: 'relative' }}>
                              <input
                                type='text'
                                className='form-control'
                                placeholder='Type to search and select user...'
                                value={userSearchTerm}
                                autoComplete='off'
                                onChange={e => {
                                  const val = e.target.value;
                                  setUserSearchTerm(val);
                                  const filtered = uniqueUsers.filter(user => {
                                    const searchLower = val.toLowerCase();
                                    return (
                                      (user.username && user.username.toLowerCase().includes(searchLower)) ||
                                      (user.name && user.name.toLowerCase().includes(searchLower))
                                    );
                                  });
                                  setFilteredUsers(filtered);
                                }}
                                onFocus={e => {
                                  if (userSearchTerm) {
                                    const filtered = uniqueUsers.filter(user => {
                                      const searchLower = userSearchTerm.toLowerCase();
                                      return (
                                        (user.username && user.username.toLowerCase().includes(searchLower)) ||
                                        (user.name && user.name.toLowerCase().includes(searchLower))
                                      );
                                    });
                                    setFilteredUsers(filtered);
                                  }
                                }}
                              />
                              {(userSearchTerm && filteredUsers.length > 0) && (
                                <div className={styles.typeaheadDropdown}>
                                  {filteredUsers.map(u => (
                                    <div
                                      key={u.id}
                                      className={styles.typeaheadOption}
                                      onClick={() => {
                                        setAssignee(u.id);
                                        setUserSearchTerm(u.username + ' - ' + u.name);
                                        setFilteredUsers([]);
                                      }}
                                    >
                                      {u.username + ' - ' + u.name}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                            {assignee && (
                              <div className='mt-2 text-success'>
                                <small>Selected: {(() => {
                                  const u = uniqueUsers.find(u => u.id === assignee);
                                  return u ? (u.username + ' - ' + u.name) : assignee;
                                })()}</small>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className={styles.modalFooter}>
                        <button className={`btn ${styles.btnOutlineSecondary}`} onClick={() => { setAssignOpen(false); setAssignRow(null); }}>Cancel</button>
                        <button className={`btn btn-warning ${styles.btnPrimary}`} disabled={!assignee} onClick={handleAssign}>Assign</button>
                      </div>
                    </div>
                  </div>
                )}
                {closeOpen && closeRow && (
                  <div className={styles.modalOverlay}>
                    <div className={`${styles.modalCard} card p-0`}>
                      <div className={`d-flex justify-content-between align-items-center ${styles.modalHeader}`}>
                        <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                          <h5 className='m-0'>Close Submission</h5>
                        </div>
                        <button className={`btn btn-danger `} onClick={() => { setCloseOpen(false); setCloseRow(null); }}>X</button>
                      </div>
                      <div className={styles.modalBody}>
                        <div className={styles.modalSection}>
                          <div className={styles.modalField}>
                            <label className='d-flex align-items-center' style={{ gap: '0.5rem' }}>
                              <input type='checkbox' checked={closeChecked} onChange={e => setCloseChecked(e.target.checked)} />
                              I have reviewed the implementation and confirm to close
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className={styles.modalFooter}>
                        <button className={`btn ${styles.btnOutlineSecondary}`} onClick={() => { setCloseOpen(false); setCloseRow(null); }}>Cancel</button>
                        <button className={`btn btn-warning ${styles.btnPrimary}`} disabled={!closeChecked} onClick={handleCloseConfirm}>Confirm</button>
                      </div>
                    </div>
                  </div>
                )}
                {/* {infoOpen && (
                  <div className={styles.modalOverlay}>
                    <div className={`${styles.modalCard} card p-0`}>
                      <div className={`d-flex justify-content-between align-items-center ${styles.modalHeader}`}>
                        <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                          <h5 className='m-0'>{infoTitle || 'Info'}</h5>
                        </div>
                        <button className={`btn btn-danger `} onClick={() => { setInfoOpen(false); }}>Close</button>
                      </div>
                      <div className={styles.modalBody}>
                        <div className={styles.modalSection}>
                          <div className={styles.modalField}>
                            {infoMessage}
                          </div>
                        </div>
                      </div>
                      <div className={styles.modalFooter}>
                        <button className={`btn btn-warning ${styles.btnPrimary}`} onClick={() => { setInfoOpen(false); }}>OK</button>
                      </div>
                    </div>
                  </div>
                )} */}
                {rejectOpen && rejectRow && (
                  <div className={styles.modalOverlay}>
                    <div className={`${styles.modalCard} card p-0`}>
                      <div className={`d-flex justify-content-between align-items-center ${styles.modalHeader}`}>
                        <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                          <h5 className='m-0'>Reject Submission</h5>
                        </div>
                        <button className={`btn btn-danger `} onClick={() => { setRejectOpen(false); setRejectRow(null); setRejectComment(''); }}>X</button>
                      </div>
                      <div className={styles.modalBody}>
                        <div className={styles.modalSection}>
                          <div className={styles.modalField}>
                            <label className='form-label'>Comment:</label>
                            <textarea 
                              className='form-control' 
                              rows='2'
                              placeholder='Enter reason for rejection...'
                              value={rejectComment}
                              onChange={(e) => setRejectComment(e.target.value)}
                            />
                          </div>
                          <div className={styles.modalField} style={{ marginTop: '1rem' }}>
                            <label className='d-flex align-items-center' style={{ gap: '0.5rem' }}>
                              <input type='checkbox' checked={rejectChecked} onChange={e => setRejectChecked(e.target.checked)} />
                              The idea submitted does not qualify for implementation
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className={styles.modalFooter}>
                        <button className={`btn ${styles.btnOutlineSecondary}`} onClick={() => { setRejectOpen(false); setRejectRow(null); setRejectComment(''); }}>Cancel</button>
                        <button className={`btn btn-warning ${styles.btnPrimary}`} disabled={!rejectChecked} onClick={handleRejectConfirm}>Confirm</button>
                      </div>
                    </div>
                  </div>
                )}
                {forwardOpen && forwardRow && (
                  <div className={styles.modalOverlay}>
                    <div className={`${styles.modalCard} card p-0`}>
                      <div className={`d-flex justify-content-between align-items-center ${styles.modalHeader}`}>
                        <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                          <h5 className='m-0'>Forward Submission</h5>
                        </div>
                        <button className={`btn btn-danger `} onClick={() => { setForwardOpen(false); setForwardRow(null); }}>X</button>
                      </div>
                      <div className={styles.modalBody}>
                        <div className={styles.modalSection}>
                          <div className={styles.modalField}>
                            <label className='font-weight-bold' style={{ display: 'block', marginBottom: '0.5rem' }}>Forward to Department:</label>
                            <select 
                              className='form-control' 
                              value={forwardDepartment} 
                              onChange={e => setForwardDepartment(e.target.value)}
                            >
                              <option value=''>Select Department</option>
                              {departments.map(dept => (
                                <option key={dept.id} value={dept.id}>{dept.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className={styles.modalFooter}>
                        <button className={`btn ${styles.btnOutlineSecondary}`} onClick={() => { setForwardOpen(false); setForwardRow(null); setForwardDepartment(''); }}>Cancel</button>
                        <button className={`btn btn-primary ${styles.btnPrimary}`} disabled={!forwardDepartment} onClick={handleForwardConfirm}>Confirm</button>
                      </div>
                    </div>
                  </div>
                )}
            </div>
        </div>
        </>
    );
};

export default Facilitation;
